<template>
  <div class="text-left pt-4">
    <h5>EDITAR EMPRESA </h5>
    <p>Aqui podra modificar datos de la empresa</p>
  </div>
  <hr class="custom-hr my-3" />
  <div>
    <div>
      <div class="container container-fluid">

        <div class="row">
            <div class="col-md-6">

              <label for="name" class="form-label text-left">Nombre</label>
              <input type="text" class="form-control" id="name" v-model="name" />

              <label for="email" class="form-label text-left">Email (Al menos un email debe escribir)</label>
              <input type="email" class="form-control" id="email" v-model="email" />
            
              <div v-for="(email, index) in optionalEmails" :key="index">
                <label :for="'emailOptional_' + index" class="form-label text-left">Otro Email (Opcional)</label>
                <div class="input-group">
                  <input :id="'emailOptional_' + index" type="email" class="form-control" v-model="optionalEmails[index]" required/>
                  <!-- Botón de eliminación -->
                  <button @click="removeOptionalEmail(index)" class="btn btn-custom">Eliminar</button>
                </div>
              </div>
              
              <button @click="addOptionalEmail" class="btn btn-secondary my-3">Agregar otro Email</button>
              
              <div>
                <label for="logo" class="form-label text-sm-center">Cambiar Logo</label>
                <input
                  type="file"
                  accept="image/jpeg, image/png, image/jpg"
                  class="form-control inputfile"
                  id="logo"
                  @change="handleLogoChange"
                />
              </div>

              <div class="btn tbn-block btn-custom mt-3" v-if="logo" @click="openImageModal(logo)">Ver Imagen</div>
            </div>

          <hr class="custom-hr my-4" />

        </div>
      </div>
    </div>
  </div>

   <!-- MODAL -->
   <ShowImagesModal
    :modalId="'imageModalLogoCompany'"
    :currentImage="currentImage"
    :currentImageName="currentImageName"
  />


</template>

<script>
  import { ref, onMounted, watch, computed } from 'vue'
  import ShowImagesModal from '../../../components/modals/ShowImages';
  import { sharedState } from '../../../Utils/StoreAsignacion'

  export default {
    name: "FormPrincipalCompany",
    emits: ['datosPrincipales'],
    props: {
      datosCompany: Object,
    },
    components: {
      ShowImagesModal,
    },
    setup(props,{ emit }) {
      const propsCompany = ref(props.datosCompany);
      const name = ref(propsCompany.value.name);
      const allEmails = computed(() => {
        return propsCompany.value.emails ? propsCompany.value.emails.split(",") : [];
      });
      const email = ref(allEmails.value[0]);
      const optionalEmails = ref(allEmails.value.slice(1));
      const logo = ref(null);
      const currentImage = ref(null);
      const currentImageName = ref('');
      const datosPrincipales = ref(null);

      const addOptionalEmail = () => {
        optionalEmails.value.push(null);
      };

      const removeOptionalEmail = (indexToRemove) => {
        if (optionalEmails.value[indexToRemove]) {
          optionalEmails.value[indexToRemove] = null;
          optionalEmails.value.splice(indexToRemove, 1);
        } else {
          optionalEmails.value.splice(indexToRemove, 1);
        }
      };

      watch(optionalEmails, () => {
        if (optionalEmails.value.length === 1 && !optionalEmails.value[0]) {
          optionalEmails.value = [];
          allEmails.value[0]
        }
      });

      const handleLogoChange = (event) => {
        const file = event.target.files[0];
        logo.value = file;
      };

      const openImageModal = (imageFile) => {
        currentImage.value = URL.createObjectURL(imageFile);
        currentImageName.value = imageFile.name;
        $('#imageModalLogoCompany').modal('show');
      };
      
      const dataMain = () => {
        const data = {
          name : name.value,
          email: email.value,
          optionalEmails: optionalEmails.value,
          logo: logo.value,
        };

        datosPrincipales.value = data;
        emit('datosPrincipales', data);
      };

      onMounted(() => {
        dataMain();
      });

      watch([name, email, optionalEmails, logo], () => {
        dataMain();
      });

      return {
        name,
        allEmails,
        email,
        optionalEmails,
        logo,
        currentImage,
        currentImageName,
        removeOptionalEmail,
        openImageModal,
        addOptionalEmail,
        handleLogoChange,
      };
    },
  };
</script>